import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './pixelClient';
// Renders nothing visible — only initializes the pixel and provides the
// standard <noscript> fallback (a hidden 1x1 tracking image).
export function MetaPixel() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <noscript data-id="element-12">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-13" />
    </noscript>;
}